import { render, staticRenderFns } from "./TextSearchResult.vue?vue&type=template&id=27b976e0"
import script from "./TextSearchResult.vue?vue&type=script&lang=js"
export * from "./TextSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports